const DEFAULT_LIMIT = 7;

const createTwoLevelCache = <K1, K2, V>({
  level1Limit = DEFAULT_LIMIT,
  level2Limit = DEFAULT_LIMIT,
}: {
  level1Limit?: number;
  level2Limit?: number;
}) => {
  const cache = new Map<K1, Map<K2, V>>();

  const get = (key1: K1, key2: K2): V | undefined => {
    const level1Cache = cache.get(key1);
    return level1Cache?.get(key2);
  };

  const set = (key1: K1, key2: K2, value: V): void => {
    let level1Cache = cache.get(key1);

    if (!level1Cache) {
      if (cache.size >= level1Limit) {
        const firstKey = cache.keys().next().value;
        if (firstKey) cache.delete(firstKey);
      }

      level1Cache = new Map([[key2, value]]);
      cache.set(key1, level1Cache);
    } else {
      level1Cache.set(key2, value);

      if (level1Cache.size > level2Limit) {
        const firstKey = level1Cache.keys().next().value;
        if (firstKey) level1Cache.delete(firstKey);
      }
    }
  };
  const has = (key1: K1, key2: K2): boolean => {
    return cache.get(key1)?.has(key2) ?? false;
  };

  return { get, set, has };
};
export { createTwoLevelCache };
